<template>
  <div>
    <div class="terms-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h2 class="subtitle">Pomoć pri kupovini</h2>
            <div>
              <p>Eurosan B2B shop</p>
              <p>OPĆI UVJETI POSLOVANJA</p>
              <p>
                Informacije o trgovačkom dru&scaron;tvu:<br />
                Eurosan d.o.o. <br />
                Bi&scaron;će polje bb<br />
                88000 Mostar
              </p>
              <p>
                Adresa elektroničke po&scaron;te:<br />
                <a href="mailto:webshop@eurosan.ba">webshop@eurosan.ba</a>
              </p>
              <p>
                Besplatni info telefon:<br />
                080 080 080
              </p>
              <p>
                Radno vrijeme telefonskih operatera je od ponedjeljka do petka od 8 do 16 sati.
                Korisnička podr&scaron;ka nije dostupna subotom, nedjeljom i za vrijeme blagdana.
              </p>
              <p>
                Poduzeće upisano u trgovački registar:<br />
                JIB: 4227197420005<br />
                PDV: 227197420005
              </p>
              <p>
                Račun u UniCredit bank d.d. <br />
                SWIFT/BIC: UNCRBA22<br />
                IBAN:
              </p>
              <p>Opće odredbe</p>
              <p>
                Eurosan d.o.o. Mostar pruža online uslugu putem Internet stranice na domeni
                <a href="http://www.eurosan.ba">www.eurosan.ba</a>
              </p>
              <p>
                Usluga se sastoji od pružanja informacijskih usluga, upravljanja sadržajem te
                provođenja financijskih transakcija.
              </p>
              <p>
                Uvjeti kori&scaron;tenja propisuju uvjete i pravila za korisnike i odnose se na
                kori&scaron;tenje internet stranice eurosan.ba. Kori&scaron;tenjem internet stranice
                korisnici iskazuju da se slažu s ovim Općim uvjetima poslovanja te pristaju na
                kori&scaron;tenje internet stranice eurosan.ba u skladu s njima. Pravo
                kori&scaron;tenja internet stranice osobno je pravo korisnika i ne može se ni na
                koji način prenositi na druge fizičke ili pravne osobe niti je bilo koji&nbsp;
                korisnik ovla&scaron;ten prijavljivati druge fizičke ili pravne osobe ili se u
                njihovo ime predstavljati. Korisnik je osobno odgovoran za za&scaron;titu
                povjerljivosti lozinki, na mjestima gdje one kao takve postoje. Korisnik je upoznat
                sa činjenicom da ponekad dolazi do prekida usluga, ili do događaja koji su izvan
                kontrole poduzeća Eurosan d.o.o. te prihvaća da poduzeće Eurosan d.o.o. nije
                odgovorno za bilo kakav gubitak podataka do kojeg može doći za vrijeme prijenosa
                informacija na internetu. Korisnik se slaže i prihvaća da pristup internet
                stranicama ponekad može biti u prekidu, privremeno nedostupan ili isključen.
              </p>
              <p>
                Poduzeće Eurosan d.o.o. zadržava pravo u bilo kojem trenutku izmijeniti ili ukinuti
                bilo koji segment poslovanja, uključujući, i bez ograničenja, sadržaj, vrijeme
                dostupnosti, kao i opremu potrebnu za pristup ili kori&scaron;tenje stranica.
                Nadalje, poduzeće Eurosan d.o.o. može prestati slati bilo koji dio informacija, ili
                bilo koju vrstu informacija, može promijeniti ili ukinuti bilo koji način prijenosa
                podataka te može promijeniti brzine prijenosa podataka, kao i bilo koje njihove
                druge karakteristike.
              </p>
              <p>
                Kori&scaron;tenjem ovih internet stranica korisnik potvrđuje da je upoznat i
                suglasan s Općim uvjetima poslovanja. Poduzeće Eurosan d.o.o. poručuje korisniku:
                Ukoliko se s ovdje navedenim uvjetima kori&scaron;tenja i pravilima ne slažete ili
                ako imate manje od 16 godina, molimo vas da se suzdržite od uporabe ove internet
                stranice.
              </p>
              <p>
                Poduzeće Eurosan d.o.o. zadržava pravo u bilo kojem trenutku, i bez prethodne
                obavijesti, ukoliko to smatra potrebnim, ukinuti ili izmijeniti bilo koji od ovdje
                navedenih Općih uvjeta poslovanja i/ili Izjavu o privatnosti. Stoga, savjetuje
                korisnike da s vremena na vrijeme ponovo pročitaju informacije sadržane u Općim
                uvjetima poslovanja i Izjavi o privatnosti, a kako bi ostali informirani o takvim
                promjenama. Nastavkom kori&scaron;tenja internet stranice i nakon objave na
                internetu novih promijenjenih Općih uvjeta poslovanja, odnosno Izjave o privatnosti,
                podrazumijeva se da korisnik prihvaća navedene izmjene.
              </p>
              <p>
                Korisnik je odgovoran za nabavu i održavanje svoje računalne opreme, uključujući sav
                softver i hardver koji posjeduje i koji koristi, kao i drugu opremu potrebnu za
                pristup i kori&scaron;tenje ovih internetskih stranica te sve sa tim povezane
                tro&scaron;kove. Poduzeće Eurosan d.o.o. nije odgovorno za bilo kakva
                o&scaron;tećenja opreme korisnika koja mogu nastati kao posljedica kori&scaron;tenja
                ove Internet stranice.
              </p>
              <p>
                Ova internet stranica privatno je vlasni&scaron;tvo. Sva međusobna komunikacija i
                interakcija koja se odvija putem ovih internet stranica mora biti u skladu s ovim
                Općim uvjetima poslovanja. Korisnici ne smiju putem ove internet stranice
                objavljivati ili prenositi bilo kakve materijale koji ugrožavaju, ili na bilo koji
                način kr&scaron;e prava drugih, bilo kakav materijal koji je po svojoj prirodi
                nezakonit, ugrožavajući, uvredljiv, klevetnički, koji naru&scaron;ava ili ugrožava
                privatnost, koji je vulgaran, opscen, ili na drugi način nepoželjan u odmjerenoj
                komunikaciji, koji potiče na protupravne aktivnosti, ili na drugi način kr&scaron;i
                bilo koji propis te koji, bez izričitog, prethodnog, pismenog odobrenja poduzeća
                Eurosan d.o.o., sadrži ogla&scaron;avanje ili ponudu bilo čijih proizvoda i usluga.
                Korisnik ne smije koristiti ovu internet stranicu za ogla&scaron;avanje ili
                izvođenje bilo kakve komercijalne, vjerske, političke, ili nekomercijalne promidžbe.
              </p>
              <p>
                Svi materijali koji se nalaze na eurosan.ba internet stranici ekskluzivno su pravo
                poduzeća Eurosan d.o.o., ili se koriste uz izričito odobrenje nositelja autorskih
                prava te nositelja prava na žigovima i/ili dizajnu. BILO KAKVO KOPIRANJE,
                DISTRIBUCIJA, PRIJENOS, OBJAVLJIVANJE, POVEZIVANJE, DUBINSKO POVEZIVANJE, ILI
                MIJENJANJE NA DRUGI NAČIN OVIH INTERNETSKIH STRANICA BEZ IZRIČITOG PISMENOG
                ODOBRENJA PODUZEĆA EUROSAN D.O.O. STROGO JE ZABRANJENO! Kr&scaron;enje Općih uvjeta
                poslovanja može dovesti do pokretanja parničnih postupaka i/ili do kaznenog progona
                protiv počinitelja radi povrede autorskih prava, prava žiga, ili prava kojeg drugog
                oblika intelektualnog vlasni&scaron;tva.
              </p>
              <p>
                Internet stranica sadrži materijale za&scaron;tićene autorskim pravom, žigom,
                dizajnom te druge informacije koje su pokrivene drugim pravima fizičkih ili pravnih
                osoba, uključujući, ali bez ograničenja na, tekstove, softver, fotografije, video
                materijale, grafiku, muziku, zvuk, kao i cijeli sadržaj internetskih stranica
                eurosan.ba, a u skladu s propisima BiH. Korisnik ne smije mijenjati, objavljivati,
                prenositi, sudjelovati u prijenosu ili prodaji, stvarati izvedenice, ili na bilo
                koji način iskori&scaron;tavati bilo koji sadržaj, u cijelosti ili djelomično.
                Korisnik može preuzimati, ispisivati i spremati materijale za&scaron;tićene
                autorskim pravom samo u svrhu svoje vlastite upotrebe. Nije dozvoljeno kopiranje,
                redistribucija, ponovni prijenos, izdavanje ili komercijalno iskori&scaron;tavanje
                preuzetog materijala bez izričitog pismenog odobrenja poduzeća Eurosan d.o.o. i
                nositelja autorskog prava.
              </p>
              <p>
                Korisnik se izričito slaže da je kori&scaron;tenje Internet stranice eurosan.ba
                isključivo odgovornost korisnika tako da poduzeće Eurosan d.o.o. ne jamči (I) ZA
                POSLJEDICE KOJE MOGU NASTATI UPOTREBOM OVE INTERNETSKE STRANICE, ILI (II) ZA
                TOČNOST, POUZDANOST ILI SADRŽAJ BILO KOJE INFORMACIJE, USLUGE ILI ROBE DATE PREKO
                OVE INTERNET STRANICE od strane korisnika.
              </p>
              <p>
                Ni u kojem slučaju poduzeće Eurosan d.o.o. neće biti odgovorno za bilo kakvu
                &scaron;tetu koja može nastati kao posljedica kori&scaron;tenja ili zbog
                nemogućnosti kori&scaron;tenja ove Internetske stranice. Korisnik izričito potvrđuje
                da se uvjeti ovog poglavlja odnose na cjelokupan sadržaj Internetske stranice.
              </p>
              <p>
                Uz prethodno navedene uvjete, poduzeće Eurosan d.o.o., neće biti odgovorno, bez
                obzira na uzrok ili trajanje, za bilo koje pogre&scaron;ke, netočnosti, ili druge
                nedostatke, neprikladnost ili neizvornost, informacija koje se nalaze na ovoj
                internetskoj stranici, kao i za bilo kakvo ka&scaron;njenje ili prekid u prijenosu
                informacija do korisnika, za bilo kakva potraživanja ili gubitke koji iz tog
                proizlaze. Eurosan d.o.o. neće biti odgovoran za bilo kakva potraživanja ili gubitke
                treće strane, uključujući i izgubljenu dobit.
              </p>
              <p>
                Poduzeće Eurosan&nbsp; d.o.o. nije odgovorno za bilo kakav sadržaj koji korisnik,
                pretplatnik, ili neovla&scaron;teni korisnik može postaviti na internetsku stranicu.
                Poduzeće Eurosan d.o.o. zadržava pravo promjene, prilagođavanja, izmjene, brisanja
                ili uklanjanja bilo kojeg sadržaja za koji ocijeni da je neprikladan.
              </p>
              <p>
                Korisnik potvrđuje da su sve recenzije i ocjene objavljene na Internet stranici
                eurosan.ba i na stranicama dru&scaron;tvenih mreža Eurosan grupe, javne a ne
                privatne prirode, i da stoga djelatnici tvrtke Eurosan d.o.o. mogu nadzirati i
                upravljati navedenom komunikacijom.
              </p>
              <p>
                Korisnik se slaže da će obe&scaron;tetiti, i neće smatrati odgovornim poduzeće
                Eurosan d.o.o., od svih zahtjeva za naknadom &scaron;tete i tro&scaron;kova,
                uključujući tro&scaron;kove pravnog zastupanja, a koji mogu nastati upotrebom ovih
                internet stranica od strane korisnika.
              </p>
              <p>
                Eurosan d.o.o. može raskinuti poslovni odnos s bilo kojim svojim korisnikom u bilo
                kojem trenutku. Eurosan d.o.o. zadržava pravo trenutno ukinuti bilo koje lozinke,
                ili korisničke račune korisnika u slučaju bilo kakvog pona&scaron;anja korisnika
                koje&nbsp; Eurosan d.o.o., prema svojoj diskrecijskoj ocjeni, smatra
                neprihvatljivim, kao i u svakom slučaju nepo&scaron;tivanja Općih uvjeta poslovanja
                od strane korisnika.
              </p>
              <p>
                Korisnik može svoje upite i komentare poslati pismeno, po&scaron;tom ili e-mailom, a
                Eurosan d.o.o. će poslati pismeni odgovor po&scaron;tom ili e-mailom u zakonskom
                roku.
              </p>
              <p>
                Eurosan je figurativno i verbalno registrirani žig&nbsp; preduzeća Eurosan&nbsp;
                d.o.o. pri ovla&scaron;tenim BiH i međunarodnim tijelima, te su stoga sva prava u
                odnosu na ovaj žig time izričito pridržana.
              </p>
              <p>Eurosan.ba je registrirana domena poduzeća Eurosan d.o.o.</p>
              <p>
                Poduzeće Eurosan d.o.o. distributer je (a ne izdavač) sadržaja vezanog za artikle
                koje prodaje. Za točnost, potpunost i korisnost bilo kojeg sadržaja o artiklima koji
                se mogu naći na ovoj internet stranici odgovornost ima izdavač tog sadržaja, odnosno
                proizvođač artikla.
              </p>
              <p>
                Poduzeće Eurosan d.o.o. nije odgovorno za točnost ili pouzdanost bilo kojeg
                mi&scaron;ljenja, savjeta ili izjave koja je objavljena na eurosan.ba internetskoj
                stranici, od strane bilo koga tko nije ovla&scaron;tena osoba tvrtke Eurosan d.o.o.
                Ni pod kojim uvjetima poduzeće Eurosan d.o.o. neće biti odgovorno za bilo kakav
                gubitak ili &scaron;tetu nastalu tim &scaron;to se korisnik oslonio na informacije
                dobivene putem eurosan.ba internet stranice. Na korisniku leži sva odgovornost
                ocijeniti točnost, kompletnost ili korisnost bilo koje informacije,
                mi&scaron;ljenja, stava, savjeta ili drugog sadržaja koji je dostupan putem
                eurosan.ba internet stranice.
              </p>
              <p>
                Sjedi&scaron;te poduzeća Eurosan d.o.o. je u Mostaru, u Bosni i Hercegovini. Pravni
                sporovi koji mogu nastati kao posljedica kori&scaron;tenja ovih internet stranica
                (osim ako posebnim ugovorom nije drugačije navedeno) u nadležnosti su Općinskog suda
                u Mostaru, i rje&scaron;avaju se u skladu s pozitivnim propisima Bosne i
                Hercegovine. Kori&scaron;tenjem ovih Internetskih stranica krajnji korisnik pristaje
                da je bilo koji spor ili zahtjev, proiza&scaron;ao iz, ili koji je u vezi s ovim
                Uvjetima, ili u vezi s njihovim provođenjem, u nadležnosti Općinskog suda u Mostaru.
                Za poduzeće Ecotime d.o.o. Sarajevo, nadležan je Općinski sud u Sarajevu, a za
                poduzeće Eurosan d.o.o. Banja Luka je nadležan Osnovni sud u Banjoj Luci.
              </p>
              <p>
                Termin &bdquo;korisnik&ldquo; podrazumijeva i fizičku i pravnu osobu te sve koji
                imaju pravnu osobnost. Radi boljeg razumijevanja potrebno je naglasiti da se prava
                iz Zakona o za&scaron;titi potro&scaron;ača odnose samo na potro&scaron;ača prema
                definiciji iz tog zakona: &bdquo;svaka fizička osoba koja sklapa pravni posao ili
                djeluje na trži&scaron;tu izvan svoje trgovačke, poslovne, obrtničke ili
                profesionalne djelatnosti&ldquo;.
              </p>
              <p>
                Uvjet za kori&scaron;tenje internet stranice eurosan.ba je uspje&scaron;na
                registracija korisnika. U okviru registracije korisniku će biti ponuđeno prihvaćanje
                ovih Općih uvjeta poslovanja i Izjave o privatnosti, čije prihvaćanje je preduvjet
                za kori&scaron;tenje usluga internet stranice eurosan.ba.
              </p>
              <p>
                Na eurosan.ba možete kupovati kao pravna osoba (B2B), kao fizička osoba i kao gost
                bez registracije (B2C). Na početku procesa kupovine bit će vam dostupni linkovi na
                sadržaj Općih uslova poslovanja kao i Izjave o privatnosti. Preporučujemo da svakako
                pročitate i upoznate se s njihovim sadržajem.
              </p>
              <p>
                Eurosan d.o.o. preporučuje korisnicima da brinu o svojoj ulaznoj lozinki za
                korisnički račun. Preporučujemo da prilikom odabira kombinacije znakova za lozinku
                kombinirate velika i mala slova s brojevima i posebnim znamenkama
                (~`!@#$%^&amp;*_-+={[}]|\:;"'&lt;,&gt;.?/) te da svakako upotrijebite lozinku od
                barem &scaron;est znakova. Lozinku preporučujemo periodično promijeniti (barem
                jednom godi&scaron;nje).
              </p>
              <p><strong>Jezik</strong></p>
              <p>
                Službeni jezici komunikacije na eurosan.ba su jezici konstitutivnih naroda Bosne i
                Hercegovine, Hrvatski, Bosanski i Srpski književni jezik.
              </p>
              <p><strong>Cijene</strong></p>
              <p>
                Cijene su izražene u konvertibilnim markama (BAM). Cijene u online trgovini za
                korisnike registrirane kao pravne osobe ne sadrže PDV. Cijene u online trgovini za
                fizičke osobe sadrže PDV.
              </p>
              <p>
                Cijena robe utvrđena je za svaki proizvod pojedinačno. Proces upisivanja cijene za
                svaki proizvod podložan je kontroli na vi&scaron;e razina, no bez obzira na to
                postoji mogućnost nastanka gre&scaron;ke jer je u pitanju ljudski faktor, a po
                prirodi stvari ne može se raditi o automatskom unosu.
              </p>
              <p>
                Takve situacije su vanredne i za njih se poduzeće Eurosan d.o.o. unaprijed izvinjava
                svojim kupcima jer će ih biti prisiljen obavijestiti o nastaloj situaciji,
                pogre&scaron;noj cijeni za određeni proizvod te nemogućnosti isporuke po konkretnoj
                narudžbi kupca.
              </p>
              <p><strong>Posebni oblici prodaje/Akcijska prodaja</strong></p>
              <p>
                Poduzeće Eurosan d.o.o. će periodično, po svojoj odluci stavljati određene proizvode
                na akcijsku prodaju odnosno organizirati posebne oblike prodaje drugih naziva.
              </p>
              <p>
                Ti proizvodi će biti dostupni svim kupcima ili će biti dostupni kupcima određene,
                točno specificirane skupine. Uvjeti posebne prodaje bit će detaljno opisani, posebno
                trajanje posebnog oblika prodaje, ograničenje količina robe, visina popusta i sl.
              </p>
              <p>
                Nakon proteka roka posebnog oblika prodaje,&nbsp; poduzeće Eurosan d.o.o. neće
                primati nove narudžbe po Uvjetima koji se odnose na posebni oblik prodaje kojem je
                istekao rok.
              </p>
              <p>&nbsp;</p>
              <p>&nbsp;</p>
              <p><strong>Narudžba</strong></p>
              <p>Proces naručivanja na eurosan.ba Internet trgovini je opisan ovdje:</p>
              <p>Za poslovne kupce:</p>
              <p>
                Ulogirajte se na svoj račun, odaberite proizvod(e) koje želite kupiti i kliknite
                'dodaj u korpu'. Otvorite korpu, te ukoliko ste zavr&scaron;ili s dodavanjem
                artikala, kliknite 'Idi na naplatu'. Odaberite adresu za dostavu, način dostave i na
                kraju način plaćanja. Kada odaberete način plaćanja, kliknite 'zaključi narudžbu' i
                nakon toga, va&scaron;a narudžba je uspje&scaron;no kreirana.
              </p>
              <p>Za privatne kupce:</p>
              <p>
                Otvorite Internet stranicu <a href="http://www.eurosan.ba">www.eurosan.ba</a>, zatim
                kliknite na webshop za fizička lica, odaberite proizvod(e) koje želite naručiti i
                kliknite 'dodaj u korpu'. Nakon toga, otvorite korpu i kliknite 'Idi na naplatu'.
                Unesite svoje podatke za dostavu koji uključuju ime, prezime, adresu, grad,
                po&scaron;tanski broj, e-mail adresu i broj telefona. Odaberite način plaćanja,
                pouzeću ili kartično i kliknite 'zaključi narudžbu'. Nakon toga, va&scaron;a
                narudžba je uspje&scaron;no kreirana.
              </p>
              <p>
                Zbog velikog broja narudžbi koje se istovremeno predaju na eurosan.ba Internet
                trgovini može se dogoditi da informacija o raspoloživosti proizvoda ne bude
                istovjetna sa stanjem na skladi&scaron;tu poduzeća Eurosan d.o.o. Takva situacija je
                izvanredna i ne traje dugo.
              </p>
              <p>
                Poduzeće Eurosan d.o.o. će poduzeti sve potrebne mjere i angažirati sve moguće
                resurse kako bi ispunio u primjerenom roku isporuku naručenog proizvoda. U slučaju
                da naručeni proizvod nije na raspolaganju, o tome će obavijestiti kupca i ponuditi
                mu mogućnost kupovine proizvoda s eurosan.ba internet trgovine koji je raspoloživ za
                isporuku i koji je po svojim karakteristikama najbliži proizvodu koji nije moguće
                isporučiti. Poduzeće Eurosan d.o.o. otklanja odgovornost za posljedice opisane
                izvanredne situacije.
              </p>
              <p>
                Obveza poduzeća Eurosan d.o.o. na isporuku proizvoda nastaje kada Eurosan izda
                potvrdu narudžbe.
              </p>
              <p>
                To je trenutak sklapanja ugovora između Kupca i poduzeća Eurosan d.o.o. kojem je
                sastavni dio tekst ovih Općih uvjeta.
              </p>
              <p>
                Proizvodi koje Kupac doda u ko&scaron;aricu ne smatraju se rezerviranim niti se
                smatra da je time nastala obveza poduzeća Eurosan d.o.o. na prodaju tih proizvoda,
                dok proces narudžbe ne bude zavr&scaron;en te Kupcu stigne potvrda narudžbe.
              </p>
              <p>
                <strong
                  >Trajanje i raskid ugovora (jednostrani raskid ugovora od strane kupca)</strong
                >
              </p>
              <p>
                Ugovor koji Kupac sklapa s poduzećem Eurosan d.o.o. za kupoprodaju proizvoda i
                usluga je jednokratan ugovor o kupoprodaji proizvoda ili usluga koji je konzumiran
                isporukom robe ili usluge od strane Eurosan d.o.o. te izvr&scaron;enim plaćanjem od
                strane Kupca, u slučaju da prethodno ne bude raskinut. Ovi Opći uvjeti poslovanja
                sastavni su dio Ugovora o kupoprodaji između Eurosan d.o.o. i Kupca.
              </p>
              <p>
                U skladu sa Zakonom o za&scaron;titi potro&scaron;ača u BiH fizička osoba Kupac
                ovla&scaron;tena je jednostrano raskinuti ugovor ne navodeći razloge za to u roku od
                15 dana od datuma isporuke proizvoda, odnosno isporuke zadnjeg proizvoda iz
                narudžbe.
              </p>
              <p>
                Iznimka od ovog ovla&scaron;tenja odnosi se na proizvode za koje čl. 48. Zakona o
                za&scaron;titi potro&scaron;ača BiH isključuje pravo na jednostrani raskid ugovora o
                čemu će vas Eurosan d.o.o. posebno upozoriti u ponudi konkretnog proizvoda.
                Preporučujemo čitati opis proizvoda koji se otvara klikom na proizvod.
              </p>
              <p>Isključenje prava na jednostrani raskid ugovora</p>
              <p>Članak 48.</p>
              <p>
                Potro&scaron;ač nema pravo na jednostrani raskid ugovora iz ovoga odsjeka ako je:
              </p>
              <p>Članak 48</p>
              <ol>
                <li>
                  Ako se strane nisu drugačije dogovorile, potro&scaron;ač ne može odustati od prava
                  na raskid ugovora iz člana 47. ovog Zakona u vezi sa ugovorima: a) o pružanju
                  usluga - ako je uz njihov pristanak počeo da radi prije nego &scaron;to je istekao
                  rok od 15 dana za odustajanje iz člana 47. ovog Zakona; b) o uslugama igara na
                  sreću; c) o prodaji robe ili usluga - ako cijena proizvoda ili usluga zavisi od
                  promjena na finansijskom trži&scaron;tu na koje potro&scaron;ač ne može uticati;
                  d) o prodaji robe - kada je potro&scaron;ač dao ličnu pisanu narudžbu ili
                  specifikaciju za proizvod; e) o prodaji robe kada se proizvod zbog njegove prirode
                  ne može vratiti; f) kod isporuke audio i video-snimaka ili računarskog uputstva
                  koje je potro&scaron;ač upotrijebio; g) kod isporuke &scaron;tampe, periodike i
                  časopisa.
                </li>
              </ol>
              <p>
                Ugovor možete jednostrano raskinuti putem nedvosmislene izjave u kojoj izražavate
                svoju volju da raskinete ugovor na trajnom mediju (mailom, podneskom i sl.).
              </p>
              <p>
                Va&scaron; zahtjev za zamjenu proizvoda koji je ispravan (npr., neodgovarajuća boja
                proizvoda)&nbsp; koji ste kupili smatrat će se jednostranim raskidom, pa Vas molimo
                da u tom slučaju posebno naglasite da želite zamjenu i obavezno ispunite obrazac za
                povrat proizvoda koji ste dobili uz proizvod kako bismo znali da prilikom raskida
                želite zamjenu proizvoda. Proizvode (povrat ili zamjena) potrebno je dostaviti na
                adresu koja je navedena na po&scaron;iljci kao adresa po&scaron;iljaoca.
              </p>
              <p>
                U slučaju jednostranog raskida ugovora&nbsp; bez zamjene proizvoda, postupat ćemo
                prema Zakonu o za&scaron;titi potro&scaron;ača odnosno Zakonu o obligacionim
                odnosima. Povrat plaćenog izvr&scaron;it ćemo vam nakon &scaron;to nam roba bude
                vraćena. Povrat robe nam morate izvr&scaron;iti bez odgađanja, na svoj
                tro&scaron;ak, a najkasnije u roku 7 dana od dana kada ste nam izjavili jednostrani
                raskid ugovora.
              </p>
              <p>
                Kupac prema Zakonu o za&scaron;titi potro&scaron;ača mora izvr&scaron;iti povrat
                robe bez odgađanja i u skladu sa zakonom od&nbsp; dana od kada je trgovca
                obavijestio o svojoj odluci da raskida ugovor, te&nbsp; snositi izravne
                tro&scaron;kove povrata robe ako koristi svoje pravo na jednostrani raskid ugovora.
                Ukoliko kupac želi može se obratiti poduzeću Eurosan d.o.o. na info broj ili mail
                adresu info@eurosan.ba radi pribavljanja&nbsp; obavijesti o načinu, mogućnostima i
                Uvjetima vraćanja proizvoda od strane poduzeća Eurosan d.o.o. Eurosan d.o.o. poziva
                kupca da proizvod zapakira u originalnu neo&scaron;tećenu ambalažu kako bi se
                izbjegla o&scaron;tećenja na proizvodu. Ako se radi o o&scaron;tećenoj ili
                specifičnoj ambalaži (npr. stiropor i folija) potrebno je učvrstiti dijelove
                ambalaže radi za&scaron;tite proizvoda kako bi u neo&scaron;tećenom obliku stigao u
                poduzeće Eurosan d.o.o.
              </p>
              <p>
                Kupac je sukladno Zakonu o za&scaron;titi potro&scaron;ača odgovoran za svako
                umanjenje vrijednosti kupljenog proizvoda koje je rezultat rukovanja kupljenim
                proizvodom, osim onog koje je bilo potrebno za utvrđivanje prirode, obilježja i
                funkcionalnosti robe &scaron;to je utvrđeno kao obveza potro&scaron;ača u slučaju
                jednostranog raskida ugovora u zakonskom roku. Poduzeće Eurosan d.o.o.
                obavje&scaron;tava kupce da će umanjenje vrijednosti kupljenog proizvoda u odnosu na
                o&scaron;tećenje ambalaže odnosno o&scaron;tećenje proizvoda koje nije uzrokovano
                provjerom funkcionalnosti proizvoda utvrđivati za svaki vraćeni proizvod pojedinačno
                te će o utvrđenom obavijestiti kupca nakon primitka vraćenog proizvoda ako postoji
                potreba za naknadom.
              </p>
              <p>
                Eurosan preporuke vezano za proizvode, preuzimanja proizvoda, postupanje s
                proizvodom a u vezi s jednostranim raskidom ugovora u zakonskom
                roku:&nbsp;&nbsp;&nbsp;
              </p>
              <p>
                - slika proizvoda&lrm; prikazuju načelan izgled te način upotrebe proizvoda kao i
                prezentaciju proizvoda kako to predviđa proizvođač. Slika ne prikazuje do detalja
                konkretan proizvod koji se isporučuje kupcu, stoga Eurosan preporučuje kupcu da
                prilikom izbora proizvoda detaljno pregleda karakteristike proizvoda i opis
                proizvoda koji su navedeni u ponudi na Internet stranici eurosan.ba i dohvaćaju se
                klikom na proizvod.&nbsp;&nbsp;&nbsp;
              </p>
              <p>
                - ako je ambalaža o&scaron;tećena nemojte preuzimati proizvod, nego odmah
                dostavljaču skrenite pažnju na o&scaron;tećenje ambalaže i zatražite da proizvod
                vrati u poduzeće Eurosan d.o.o. AKO KUPAC NE REKLAMIRA O&Scaron;TEĆENJE AMBALAŽE
                DOSTAVLJAČU U TRENUTKU PREUZIMANJA PROIZVODA, SMATRA SE DA JE PREUZEO PROIZVOD S
                NEO&Scaron;TEĆENOM AMBALAŽOM.
              </p>
              <p>
                - ukoliko o&scaron;tećenje na proizvodu utvrdite nakon skidanja ambalaže, sačuvajte
                originalnu ambalažu i &scaron;to prije a najkasnije u zakonom propisanom roku a od
                dana primitka robe kontaktirajte poduzeće Eurosan d.o.o. Ako Eurosan organizira
                prijevoz robe radi povrata, potrebno je proizvod zapakovati u originalnu
                neo&scaron;tećenu ambalažu kako bi se izbjegla o&scaron;tećenja na proizvodu. Ako se
                radi o o&scaron;tećenoj ili specifičnoj ambalaži (npr. stiropor i folija) potrebno
                je učvrstiti dijelove ambalaže radi za&scaron;tite proizvoda.
              </p>
              <p>
                - ako je ambalaža neo&scaron;tećena i preuzeli ste proizvod, pažljivo skinite
                ambalažu uz &scaron;to manje o&scaron;tećivanje jer o&scaron;tećena ambalaža
                umanjuje vrijednost proizvoda.
              </p>
              <p>
                - pažljivo pregledajte proizvod, njegovu prirodu, obilježja i&nbsp; funkcionalnost
                (npr. aktivirajte uređaj na struju ili bateriju, pažljivo provjerite držače, da li
                ispravno funkcioniraju, da li senzor radi, i sl.) ali nemojte proizvod koristiti ili
                njime rukovati jer svako daljnje rukovanje proizvodom umanjuje vrijednost
                proizvoda.&nbsp;
              </p>
              <p>
                Rukovanjem/kori&scaron;tenjem proizvoda smatra se primjerice držači sapuna &ndash;
                pranje ruku, za za&scaron;titnu opremu &ndash; kori&scaron;tenje/hodanje u cipelama,
                za krpe i spužve &ndash; brisanje pra&scaron;ine i pranje posuđa, za usisivač
                &ndash; usisavanje prostorija. Rukovanje proizvodom umanjuje vrijednost proizvoda.
              </p>
              <p>
                Poduzeće Eurosan d.o.o. obavje&scaron;tava kupce o specifičnim svojstvima pojedinih
                proizvoda kao &scaron;to su: usisivači, ma&scaron;ine za či&scaron;ćenje, ribanje i
                usisavanje i dr., gdje zbog njihovih karakteristika nije moguće provjeriti njihovu
                funkcionalnost bez rukovanja proizvodom npr. montiranja/stavljanja u
                funkciju/sastavljanja. Iz tog razloga Eurosan neće biti u mogućnosti izvr&scaron;iti
                povrat kupoprodajne cijene (u cijelosti ili djelomično) za ove proizvode u slučaju
                kada je za povrat naveden razlog: provjera funkcionalnosti jer sama provjera
                funkcionalnosti umanjuje vrijednost proizvoda time &scaron;to se stanje proizvoda
                nepovratno mijenja.
              </p>
              <p>
                Poduzeće Eurosan d.o.o. obavje&scaron;tava kupce da u pojedinim proizvodima koji
                spadaju u kategoriju bijele tehnike, a za svoj rad koriste vodu (npr. perilice) može
                preostati mala količina vode nakon testiranja u procesu proizvodnje koja uobičajeno
                iscuri za vrijeme skladi&scaron;tenja. Stoga poduzeće Eurosan d.o.o.
                obavje&scaron;tava kupce da proizvode tog tipa ostave do trenutka montaže na podlozi
                koja ne upija vodu.
              </p>
              <p>
                U slučaju da Kupac naruči robu i odbije ju primiti bez razloga (ambalaža nije
                o&scaron;tećena), poduzeće Eurosan d.o.o. ima pravo uskratiti od uplaćenog iznosa
                kupoprodajne cijene iznos izravnih tro&scaron;kova povrata proizvoda.
              </p>
              <p>
                Poduzeće Eurosan d.o.o. odgovara za materijalne nedostatke stvari koje prodaje na
                svojim stranicama sukladno pozitivnim propisima posebice Zakonu o obligacionim
                odnosima u BiH.
              </p>
              <p>
                Obavijest o statusu vraćenog proizvoda i ostvarenom iznosu povrata kupac će primiti
                u roku od 10 dana putem maila. Povrat novčanih sredstava kupcu bit će izvr&scaron;en
                najkasnije u roku od 5 dana od datuma upućivanja obavijesti kupcu.
              </p>
              <p>
                Cjelovite informacije vezane uz pravo kupca na jednostrani raskid ugovora možete
                pronaći u Zakonu o za&scaron;titi potro&scaron;ača.
              </p>
              <p><strong>Pisani prigovor, odgovor, obavijesti</strong></p>
              <p>
                U slučaju da ste iz bilo kojeg razloga nezadovoljni možete uputiti prigovor poduzeću
                Eurosan d.o.o.
              </p>
              <p>
                Poduzeće Eurosan d.o.o. vam omogućava podno&scaron;enje pisanog prigovora putem
                po&scaron;te na adresu sjedi&scaron;ta Eurosan d.o.o., besplatnog telefona 080 080
                080 ili putem maila info@eurosan.ba. Radi &scaron;to bržeg utvrđivanja konkretne
                narudžbe na koju imate prigovor, u prigovoru navedite broj narudžbe, broj računa ili
                svoje korisničko ime. Poduzeće Eurosan d.o.o. će vam potvrditi primitak prigovora
                pisanim putem bez odgađanja, a odgovor vam po Zakonu mora stići u roku od 7 (sedam)
                dana od dana zaprimljenog prigovora.
              </p>
              <p><strong>Načini plaćanja</strong></p>
              <p>
                Eurosan Vam omogućava kupovinu odabranih proizvoda plaćanjem direktno putem
                interneta i to:
              </p>
              <p>Za poslovne kupce:</p>
              <ol>
                <li>Plaćanje gotovinom</li>
              </ol>
              <p>
                Opcija plaćanja pouzećem vam omogućava da iznos narudžbe podmirite prilikom same
                dostave na navedenu adresu, tek kada robu vidite pred sobom. Plaćanje pouzećem se
                vr&scaron;i isključivo u gotovini, dostavljaču prilikom same isporuke na navedenu
                adresu. U slučaju da primatelj nije u mogućnosti zaprimiti po&scaron;iljku na
                definiranoj dostavnoj adresi u trenutku dostave, dostavljač ostavlja obavijest o
                prispijeću po&scaron;iljke.
              </p>
              <ol start="2">
                <li>
                  Plaćanje po predračunu<br />
                  Kod izbora ovog načina plaćanja, na svoju e-mail adresu ćete dobiti predračun sa
                  svim podacima potrebnim za uplatu, uključujući broj računa na koji trebate
                  uplatiti vrijednost narudžbe. Uplatu potom možete izvr&scaron;iti
                  kori&scaron;tenjem internet bankarstva ili načinom na koji inače plaćate svoje
                  račune - putem banke, po&scaron;te, ili sl. Po zaprimljenoj uplati, poslat ćemo
                  vam naručene proizvode.
                </li>
                <li>Virmansko plaćanje</li>
              </ol>
              <p>
                U dogovoru sa poduzećem Eurosan d.o.o., poslovni kupac može dobiti odgodu plaćanja u
                određenom vremenskom periodu. Svi detalji ovog načina plaćanja se dogovaraju
                direktno s poduzećem Eurosan d.o.o., a mogućnosti odgode ovise od kupca do kupca.
              </p>
              <p>Za privatne kupce:</p>
              <ol>
                <li>Plaćanje gotovinom po primitku po&scaron;iljke- pouzećem:</li>
              </ol>
              <p>
                Opcija plaćanja pouzećem vam omogućava da iznos narudžbe podmirite prilikom same
                dostave na navedenu adresu, tek kada robu vidite pred sobom. Plaćanje pouzećem nije
                moguće kod ličnog preuzimanja na na&scaron;em skladi&scaron;tu. Plaćanje pouzećem se
                vr&scaron;i isključivo u gotovini, dostavljaču prilikom same isporuke na navedenu
                adresu. U slučaju da primatelj nije u mogućnosti zaprimiti po&scaron;iljku na
                definiranoj dostavnoj adresi u trenutku dostave, dostavljač ostavlja obavijest o
                prispijeću po&scaron;iljke.
              </p>
              <ol start="2">
                <li>Jednokratno plaćanje karticama:</li>
              </ol>
              <ul>
                <li>VISA, MasterCard i Maestro</li>
              </ul>
              <p>
                Zavr&scaron;avanje narudžbe poduzeću Eurosan d.o.o. daje ovlast da tereti Va&scaron;
                račun za plaćanja napravljena u eurosan.ba Internet Trgovini kreditnom ili debitnom
                karticom. Plaćanje će se izvr&scaron;iti čim zavr&scaron;ite narudžbu. Kako biste
                izbjegli ka&scaron;njenja u obradi Va&scaron;e narudžbe, molimo Vas da se pobrinete
                da su Va&scaron;e ime, broj kartice, datum isteka i sigurnosni kod ispravno uneseni,
                kao &scaron;to je prikazano na Va&scaron;oj kartici.
              </p>
              <p>
                Sigurnosni kod čine tri znamenke ispisane na vrhu polja za potpis na poleđini
                Va&scaron;e MasterCard, Maestro ili VISA kartice.
              </p>
              <p>
                U slučaju bilo kakvih pitanja ili pote&scaron;koća s Va&scaron;om narudžbom, molimo
                Vas da nazovete na&scaron; tim za podr&scaron;ku korisnicima na tel. 080 080
                080&nbsp; pon &ndash; pet, 08:00 &ndash; 16:00 h ili putem mail-a na
                <a href="mailto:webshop@eurosan.ba">webshop@eurosan.ba</a>
              </p>
              <p><strong>Osobno preuzimanje</strong></p>
              <p>
                Osobno preuzimanje robe u poduzeću je besplatno te se ne naplaćuju tro&scaron;kovi
                dostave. Naručene i plaćene odabrane proizvode možete osobno preuzeti na sljedećim
                lokacijama:
              </p>
              <ol>
                <li>Mostar</li>
              </ol>
              <p>
                Eurosan d.o.o. Mostar<br />
                Bi&scaron;će polje bb, 88000 Mostar<br />
                080 080 080 <br />
                Radno vrijeme: ponedjeljak &ndash; petak 8:00 &ndash; 16:00
              </p>
              <ol start="2">
                <li>Sarajevo</li>
              </ol>
              <p>
                Ecotime d.o.o. Sarajevo<br />
                Lužansko polje 7, 71210 Sarajevo<br />
                033 765 075<br />
                Radno vrijeme:<br />
                Ponedjeljak &ndash; petak 8:00 &ndash; 16:00<br />
                Subota 8.00 &ndash; 12:00
              </p>
              <ol start="3">
                <li>Banja Luka</li>
              </ol>
              <p>
                Eurosan d.o.o. Banja Luka<br />
                Jovana Bijelića, 78000 Banja Luka<br />
                051 456 652<br />
                Radno vrijeme:<br />
                Ponedjeljak &ndash; petak 8:00 &ndash; 16:00<br />
                Subota 9:00 &ndash; 13:00
              </p>
              <p>
                Na va&scaron;u mail adresu doći će obavijest s informacijom da je va&scaron;a
                narudžba spremna za isporuku. Za plaćanje po predračunu, roba se isporučuje tek
                nakon &scaron;to uplatu proknjižimo (prema izvodima iz banke &ndash; u pravilu,
                sljedeći radi dan).
              </p>
              <p>&nbsp;</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Help',
  metaInfo() {
    return {
      title: 'Pomoc - Eurosan',
      meta: [
        { name: 'description', content: 'Novosti iz svijeta Eurosan grupacije.' },
      ],
    };
  },
};
</script>
